/**
 * E.164 for India, which is the only country v1 sells in (ARCHITECTURE §4: phones are
 * stored `+91XXXXXXXXXX`).
 *
 * The api validates it again — `_e164` in `modules/scheduling/router.py` — so this exists
 * to stop a typo becoming a round trip and a 422, not to be the rule.
 */

/** The default country code the keypad prefills (§6: "E.164 IN default"). */
export const DEFAULT_CC = '+91';

/** An Indian mobile number is ten digits and never starts with 0–5. */
const INDIAN_MOBILE = /^[6-9]\d{9}$/;

/** Everything that is not a digit, dropped; a leading `+` is kept. */
export function digitsOf(raw: string): string {
  return raw.replace(/\D/g, '');
}

/**
 * `raw` as E.164, or `null` when it cannot be one.
 *
 * Accepts the four shapes a person actually types: `9820992626`, `09820992626`,
 * `919820992626` and `+91 98209 92626`.
 */
export function toE164(raw: string): string | null {
  const digits = digitsOf(raw);
  const national = digits.startsWith('91')
    ? digits.slice(2)
    : digits.startsWith('0')
      ? digits.slice(1)
      : digits;
  return INDIAN_MOBILE.test(national) ? `${DEFAULT_CC}${national}` : null;
}

/** True when `raw` is a number the api would accept. */
export function isValidPhone(raw: string): boolean {
  return toE164(raw) !== null;
}

/** `+919820992626` → `+91 98209 92626`, for reading back what was typed. */
export function prettyPhone(e164: string): string {
  const national = e164.slice(DEFAULT_CC.length);
  return `${DEFAULT_CC} ${national.slice(0, 5)} ${national.slice(5)}`;
}
